import React from 'react';
import { format, parse } from 'date-fns';
import { fr } from 'date-fns/locale';
import { CalendarIcon, X } from 'lucide-react';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

// Sélecteur de date en français ; valeur au format AAAA-MM-JJ (chaîne vide = aucune date).
export const DateFieldFr = ({ value, onChange, placeholder = 'jj/mm/aaaa', testid }) => {
  const date = value ? parse(value, 'yyyy-MM-dd', new Date()) : undefined;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="flex h-9 w-40 items-center gap-2 rounded-md border px-2 text-left text-sm" data-testid={testid}>
          <CalendarIcon className="h-4 w-4 text-slate-500" />
          <span className={date ? '' : 'text-slate-400'}>{date ? format(date, 'dd/MM/yyyy') : placeholder}</span>
          {date && (
            <X className="ml-auto h-3 w-3 text-slate-500" onClick={(e) => { e.stopPropagation(); onChange(''); }} data-testid={`${testid}-clear`} />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={fr} weekStartsOn={1} selected={date} defaultMonth={date}
          captionLayout="dropdown-buttons" fromYear={2020} toYear={new Date().getFullYear() + 2} showOutsideDays={false}
          classNames={{ caption_dropdowns: 'flex gap-1', caption_label: 'hidden', dropdown: 'rounded border px-1 text-sm', vhidden: 'hidden' }}
          onSelect={(d) => onChange(d ? format(d, 'yyyy-MM-dd') : '')} initialFocus />
      </PopoverContent>
    </Popover>
  );
};
